import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { useEffect, useState } from "react";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import ContentBalanceTransfer from "./content";
import TableBalance from "./tableBalance";
import { useQuery } from "@tanstack/react-query";
import { fetchListTransaction } from "@/api/merchant/request.get";
import ContentSkeleton from "../content.skeleton";
/**
 * BalanceTransfer
 *
 * کامپوننت مدیریت انتقال موجودی.
 *
 * ویژگی‌ها:
 * - نمایش عنوان صفحه با آیکون کارت
 * - مدیریت فراخوانی تراکنش‌ها با pagination
 * - شامل کامپوننت ContentBalanceTransfer برای انجام درخواست انتقال
 * - نمایش تراکنش‌ها در TableBalance
 *
 * @returns JSX.Element
 */
// Task Response:

// کامپوننت درست کار می‌کند، اما چند نکته برای بهبود وجود دارد:

// 1. useEffect و enabled در useQuery:
//    می‌توانید از گزینه refetch استفاده کنید و enabled را ثابت نگه دارید تا پیچیدگی کمتر شود.
// 2. state های page و size بهتر است عدد باشند نه رشته، مگر API الزامی دارد.
// 3. state value و setValue فقط برای TableBalance است، ممکن است به نام معنادارتر تغییر یابد (مثلاً rowsPerPage).
// 4. setEnableRequest می‌تواند به useQuery مستقیم متصل شود با refetch برای بهینه‌سازی فراخوانی داده‌ها.
// 5. style های inline بهتر است به sx یا کلاس‌ها منتقل شوند تا کد تمیزتر شود.

const BalanceTransfer = () => {
  const [page, setPage] = useState("1");
  const [size, setSize] = useState("10");
  const [value, setValue] = useState(10);
  const [enableRequest, setEnableRequest] = useState(true);
  
  const { data, isFetched, isLoading, isSuccess } = useQuery({
    queryKey: ["ListTransaction-data", page, size],
    queryFn: () => fetchListTransaction(page, size),
    enabled: enableRequest,
  });

  useEffect(() => {
    if (isSuccess) {
      setEnableRequest(false);
    }
  }, [isSuccess]);

  return (
    <StackKit direction={"column"} sx={{ width: "100%" }} gap={2}>
      <StackKit direction={"row"} sx={{ width: "100%", gap: "10px", display: 'flex', alignItems: 'center', justifyContent: { sm: 'start', xs: 'center' } }}>
        <CreditCardOutlinedIcon sx={{ color: "#fff", ml: "0px" }} />
        <TypoGraphyKit sx={{ ml: "0 !important" }} variant="h6">
          انتقال موجودی
        </TypoGraphyKit>
      </StackKit>
      <ContentBalanceTransfer setEnableRequest={setEnableRequest} />
      {isLoading ?
        <ContentSkeleton />
        :
        <TableBalance data={data} setValue={setValue} value={value} />
      }
    </StackKit>
  );
};

export default BalanceTransfer;
